import { render, staticRenderFns } from "./jump.vue?vue&type=template&id=4cda3ca2&scoped=true&"
import script from "./jump.vue?vue&type=script&lang=js&"
export * from "./jump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda3ca2",
  null
  
)

export default component.exports